export const STATUS_COLORS = {
  new: "bg-[#FF5A00] text-white",
  contacted: "bg-blue-500/20 text-blue-300 border border-blue-500/30",
  won: "bg-emerald-500/20 text-emerald-300 border border-emerald-500/30",
  lost: "bg-neutral-500/20 text-neutral-300 border border-neutral-500/30",
};

export const STATUS_LABEL = {
  new: "Nouveau",
  contacted: "Contacté",
  won: "Gagné",
  lost: "Perdu",
};
